import { Workbox } from "workbox-window";

export default function registerServiceWorker() {
  //@todo remove static data
  // window._siteProps_ = JSON.parse('{"name":"JFL CMS","platform":"PWA","platform_id":"4","category_id":"12","category_name":"Store","language":"English","domain":"s3-ext-alb-929978342.ap-south-1.elb.amazonaws.com","props":{"apibaseurl3":"https://s3.dominosindia.in","apibaseurl2":"https://s3.dominosindia.in","app_version":"V0.0.2","build_env_var":"stage3","apibaseurl":"https://s3.dominosindia.in","google_maps_api_key_map":"AIzaSyAsPZNa39tM9gfIDOf-_GIdmcjqTqbRTLA","google_api_base_url":"https://www.googleapis.com","userActivityTrackingSwitch":"false","autoApplyOffer":"{\\"type\\":\\"WELCOME\\",\\"code\\":\\"COUPONTEST\\"}","imgbaseurl":"https://images.dominos.co.in","v2pwabasepath":"https://s3-csr-pwa.dominosindia.in","apiBaseUrlInternal":"https://s3.dominosindia.in","staticimgbaseurl":"https://s3-csr-pwa.dominosindia.in/jfl-discovery-ui/public/dist/default","offer_version":"0.0.1","enableMenuSequencing":"true","maxShownDistance":"30","projectbasepathwithfolder":"https://s3-csr-pwa.dominosindia.in/jfl-discovery-ui/en/pwa"},"under_maintainance":"0","siteContext":"jflcms-hongs","favicon":"","profile":"stage","link_rewrite":"store","lang_id":"1"}')

  if ("serviceWorker" in navigator) {
    const swfilePath =
      window._siteProps_?.props?.staticimgbaseurl?.replace("/default", "") +
      "/sw.js" +
      "?v=" +
      window.version;
    // const swfilePath =
    //   "http://localhost:8080/jfl-discovery-ui/public/dist/sw.js";
    const wb = new Workbox(swfilePath);
    // const wb = new Workbox("http://localhost:8080/hongs-ui-web/sw.js");
    // @todo: a Modal ui will be created for this
    const showSkipWaitingModal = (event) => {
      if (confirm(`New sw app update is available!. Click OK to refresh`)) {
        wb.addEventListener("controlling", (event) => {
          console.log(event + "accepted prompt.....will reload now");

          window.location.reload();

          console.log(
            "reloaded browser.....Now service worker installed and UPDATED. New app update is available!"
          );
        });

        wb.messageSkipWaiting();
      } else {
        console.log("dismissed prompt.....");
      }
    };

    // 4. Service worker activated
    wb.addEventListener("activated", (event) => {
      if (!event.isUpdate) {
        console.info("Service worker activated for the first time!");
        wb.messageSW({
          type: "CLIENTS_CLAIM",
        });
      } else {
        console.info("Service worker activated!");
      }
    });

    // 3. service worker has installed but is waiting to activate.
    wb.addEventListener("waiting", showSkipWaitingModal);

    // 2. Service worker installed
    wb.addEventListener("installed", (event) => {
      if (!event.isUpdate) {
        console.info("Service worker installed for the first time");
      } else {
        console.info("Service worker installed");
      }
    });

    // 1. Service worker Registered
    // todo :commenting for now
    navigator.serviceWorker
      .register(swfilePath, {
        scope: "/jfl-discovery-ui",
      })
      .then(() => {
        console.log(
          "Install succeeded as the max allowed scope was overriden to '/jfl-discovery-ui'..."
        );
      });
  } else {
    console.log(
      "Service Worker is not supported in your browser, kindly update your browser for a smooth experience."
    );
  }

  // var defferedPrompt;
  // window.addEventListener('beforeinstallprompt', (event) => {
  //   console.log("beforeinstallprompt");
  //   event.preventDefault();
  //   defferedPrompt = event;
  //   showInstallPromotion();
  // })
}
